// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1TEW5","cell":"ColumnAccessor_cell__O6K4Z","firstCellAccent":"ColumnAccessor_firstCellAccent__cyUeG"};